import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { IPartnerGroupAdditionalInfo } from '../../../models/IPartnerGroupAdditionalInfo'

import { AddNewVersionContent } from './AddNewVersionContent'
import { IAddNewVersion } from './models'

interface IProps {
  show: boolean
  partnerGroupInfo: IPartnerGroupAdditionalInfo
  partnerId: string
  eltType: EltType
  wip?: boolean
  addNewVersion: (args: IAddNewVersion) => void
  onClose: () => void
}

export const AddNewVersionDialog = ({
  partnerGroupInfo,
  addNewVersion,
  partnerId,
  show,
  onClose,
  wip,
  eltType,
}: IProps) => {
  const {
    jbpSettings: { fYearELT, fQuarterELT },
  } = useJbpSettings()

  const contentProps = useMemo(
    () => ({
      partnerGroupInfo,
      fYear: fYearELT,
      addNewVersion,
      partnerId,
      fQuarter: fQuarterELT,
      wip,
      eltType,
    }),
    [partnerGroupInfo, fYearELT, addNewVersion, partnerId, fQuarterELT, wip, eltType]
  )

  return (
    <ModalDialog
      size={'xs'}
      content={AddNewVersionContent}
      contentProps={contentProps}
      show={show && !wip}
      closeOnOutsideClick={false}
      onClose={onClose}
    />
  )
}
